import styled from 'styled-components'

export const Step = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  display: flex;
  align-items: stretch;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const StepIconContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;

  & > svg {
    margin: 0.2rem;
    width: 1.2rem;
    min-width: 1.2rem;
    height: 1.2rem;
    min-height: 1.2rem;
    align-self: center;
  }
`

export const StepContact = styled.span<{ $isVisible?: boolean }>`
  flex: 1;
  background: ${props => props.color};
  width: 0.3rem;
  align-self: center;
  border-radius: ${({ theme }) => theme.borderRadius.md}rem;
  margin-top: ${({ theme }) => theme.spacing.xxs}rem;
  opacity: ${({ $isVisible }) => ($isVisible ? 1 : 0)};
`

export const StepContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 2.6rem;
  padding-top: ${({ theme }) => theme.spacing.xxs}rem;
  padding-bottom: ${({ theme }) => theme.spacing.md}rem;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const StepTitle = styled.h4`
  margin: 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing.xs}rem;
`

export const StepDescription = styled.div`
  font-size: ${({ theme }) => theme.fontSize.md}rem;
`
